

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component Attribute Properties ------------------------------------------

    props: {
        href: {
            type: String,
            required: true
        }
    }

    // -------------------------------------------------------------------------
});
